module.exports = "/_next/static/resources/art-c083a0915ed893ad17c84946351b7f30.jpg";